import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"

const DEFAULT_TITLE = "卵巣年齢チェック"

const routes: Array<RouteRecordRaw> = [
  { 
    path: "/", 
    name: "AgeInputViewForStart",
    meta: {
      title: DEFAULT_TITLE,
      description: "かんたん1分で、年齢・初潮時期・生理周期の3項目からあなたの卵巣年齢をチェックできます。",
    },
    component: () => import("../views/AgeInputView.vue") },
  {
    path: "/age",
    name: "AgeInputView",
    meta: {
      title: DEFAULT_TITLE + " | 年齢入力",
      description: "卵巣年齢チェックの年齢入力画面です。年齢・初潮時期・生理周期の3項目からあなたの卵巣年齢をチェックできます。",
    },
    component: () => import("../views/AgeInputView.vue"),
  },
  {
    path: "/menarche",
    name: "MenarcheInputView",
    meta: {
      title: DEFAULT_TITLE + " | 初潮年齢入力",
      description: "卵巣年齢チェックの初潮開始年齢入力画面です。年齢・初潮時期・生理周期の3項目からあなたの卵巣年齢をチェックできます。",
    },
    component: () => import("../views/MenarcheInputView.vue"),
  },
  {
    path: "/menstruation",
    name: "MenstruationInputView",
    meta: {
      title: DEFAULT_TITLE + " | 月経周期入力",
      description: "卵巣年齢チェックの月経周期入力画面です。年齢・初潮時期・生理周期の3項目からあなたの卵巣年齢をチェックできます。",
    },
    component: () => import("../views/MenstruationInputView.vue"),
  },
  {
    path: "/result",
    name: "ResultView",
    meta: {
      title: DEFAULT_TITLE + " | 結果",
      description: "卵巣年齢チェックの結果画面です。あなたの推定卵巣年齢と、AMHや卵子の質・量について解説しています。",
    },
    component: () => import("../views/ResultView.vue"),
  },
  {
    path: "/line",
    name: "LineFriendView",
    meta: {
      title: DEFAULT_TITLE + " | LINE友だち追加",
      description: "LINEの友だち追加を行うと、年齢・初潮時期・生理周期の3項目からあなたの卵巣年齢をチェックできます。",
    },
    component: () => import("../views/LineFriendView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFoundView",
    component: () => import("../views/NotFoundView.vue"),
  },
]

const router = createRouter({
  history: createWebHistory("/amh/"),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        top: 0
      }
    }
  },
})

router.beforeEach(async (to, _, next) => {
  if (to.path === "/menarche") {
    const age = sessionStorage.getItem("age")
    if (age === null) {
      next({ path: "/" })
      return
    }
  } else if (to.path === "/menstruation") {
    const age = sessionStorage.getItem("age")
    const menarche = sessionStorage.getItem("menarche")
    if (age === null || menarche === null) {
      next({ path: "/" })
      return
    }
  // } else if (to.path === "/result") {
  //   const result = sessionStorage.getItem("result")
  //   if (result === null) {
  //     next({ path: "/" })
  //     return
  //   }
  }
  next()
})

router.afterEach((to, _) => {
  const title = to.meta.title ?? DEFAULT_TITLE
  document.title = title as string

  const descriptionTag = document.querySelector('head meta[name="description"]')
  if (to.meta && to.meta.description) {
    if (descriptionTag) {
      descriptionTag.setAttribute('content', to.meta.description as string)
    } else {
      const newDescriptionTag = document.createElement('meta')
      newDescriptionTag.name = 'description'
      newDescriptionTag.content = to.meta.description as string
      document.head.appendChild(newDescriptionTag)
    }
  } else {
    if (descriptionTag) {
      descriptionTag.setAttribute('content', 'デフォルトの説明')
    }
  }
})

export default router
